<template>
    <div>
        <span
            v-if="counterSoonShow"
            class="badge badge-warning badge-pill my-pill"
        >
            {{ values.soon }}
        </span>
        <span
            v-if="counterLateShow"
            class="badge badge-danger badge-pill my-pill"
        >
            {{ values.late }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'Counter',

    props: {
        values: {
            soon: 0,
            late: 0,
        },
    },

    computed: {
        counterSoonShow() {
            return this.values.soon > 0
        },
        counterLateShow() {
            return this.values.late > 0
        },
    },
}
</script>

<style scoped></style>
